import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { PATIENT_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import { createPatient, updatePatient } from "services/patient";
import { useSelector } from "react-redux";
import zoneLocalStorageId from "utils/zone";
import companyLocalStorageId from "utils/companyID";

const AddPatient = ({ onClose, rowData }) => {
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const {
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: useMemo(() => {
      return rowData;
    }, [rowData]),
  });
  const { showAlert } = useAlert();

  const [createdDoctorData, setCreatedDoctorData] = useState(null);

  const onSuccess = (response) => {
    const refetchPatients = true;
    const message = rowData
      ? "Patient Details updated successfully!"
      : "Patient Details created successfully!";
    showAlert(message, "success");

    if (response?.data) {
      setCreatedDoctorData(response.data);
    }

    onClose(refetchPatients, response?.data);
  };

  const onError = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;
    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: addPatientMutate } = useMutation({
    mutationFn: createPatient,
    onSuccess,
    onError,
  });

  const { mutate: updatePatientMutate } = useMutation({
    mutationFn: updatePatient,
    onSuccess,
    onError,
  });

  const formatDateToYyyyMmDd = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const SubmitPatients = async (values, e) => {
    e.preventDefault();

    if (values.email === "" || values.email == null) {
      delete values.email;
    }

    let ageInDays;
    if (typeof values.age === "string" && values.age.includes("-")) {
      const [years, months, days] = values.age.split("-").map(Number);
      ageInDays = years * 365 + months * 30 + days;
    } else {
      ageInDays = values.age * 365;
    }

    const payload = {
      ...values,
      patient_name: values.patient_name?.toUpperCase(),
      zone_id: values.zone_id?.value ?? values.zone_id ?? zoneLocalStorageId(),
      state_id: values?.state_id,
      dob: formatDateToYyyyMmDd(values.dob),
      country_code: "IN",
      created_by: jwtAuthreducer.user.employee_code_id,
      refer_doctor_id: parseInt(values.refer_doctor_id),
      age: `P${ageInDays}D`,
      franchise_id: values.franchise?.value ?? values.franchise,
      is_active: true,
      company_id: companyLocalStorageId(),
    };
    if (rowData) {
      updatePatientMutate({
        ...rowData,
        ...payload,
      });
    } else {
      addPatientMutate(payload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <CustomForm
      config={PATIENT_FORM_CONFIG(rowData)}
      onSubmit={SubmitPatients}
      columnCount={3}
      rowData={rowData}
      // isAdditional={PATIENT_FORM_CONFIG(rowData).length > 12 ? true : false}
    />
  );
};

export default AddPatient;
